import { Form, Icon, Input, Tooltip } from 'antd'
import React from 'react'
import LoadingButton from 'src/components/styled/LoadingButton'
import styled from 'styled-components/macro'

const { Item } = Form

const NormalLoginForm = ({ submit, form, user }) => {
  const { getFieldDecorator } = form
  const { isLoading } = user

  const handleSubmit = () => {
    form.validateFields((error, values) => {
      if (!error) submit(values)
      else console.log('Error', error)
    })
  }

  return (
    <StyledForm
      onSubmit={event => {
        event.preventDefault()
        if (!isLoading) {
          handleSubmit()
        }
      }}
      className='login-form'
    >
      <Item>
        <FieldLabel>Email Address</FieldLabel>
        {getFieldDecorator('email', {
          rules: [
            { required: true, message: 'Please input your email address' },
            { type: 'email', message: 'The input is not valid email' },
          ],
        })(
          <Input
            prefix={<StyledInputIcon type='user' />}
            placeholder='name@company.com'
            size='large'
            data-testid='login-email'
          />,
        )}
      </Item>
      <Item>
        <FieldLabel>Password</FieldLabel>
        {getFieldDecorator('password', {
          rules: [{ required: true, message: 'Please input your password' }],
        })(
          <Input.Password
            prefix={<StyledInputIcon type='lock' />}
            type='password'
            placeholder='Password'
            size='large'
            data-testid='login-password'
          />,
        )}
      </Item>

      <ActionItem>
        <LoadingButton
          type='primary'
          htmlType='submit'
          className='login-form-button login-submit-button'
          loading={isLoading}
          size='large'
          data-testid='login-submit'
        >
          Log In
        </LoadingButton>
        <AuthLink href='https://ordersmadesimple.com/register/'>
          Register
        </AuthLink>
        <AuthLink href='/reset-password'>Reset Password</AuthLink>
      </ActionItem>
      <Item className='login-tooltip-item'>
        <Tooltip
          placement='bottom'
          trigger='click'
          title='Passwords must contain, at least one number, one special character, one uppercase letter and one lowercase letter, and it must be 8 or more characters long.'
        >
          <TooltipHint>
            <Icon type='info-circle' />
            Password requirements
          </TooltipHint>
        </Tooltip>
      </Item>
    </StyledForm>
  )
}

const StyledForm = styled(Form)`
  .ant-form-item {
    margin-bottom: 14px;
  }

  .ant-input-affix-wrapper .ant-input {
    border-radius: 8px;
  }

  .ant-input-affix-wrapper:hover .ant-input:not(.ant-input-disabled) {
    border-color: rgba(19, 45, 7, 0.34);
  }

  .ant-input-affix-wrapper-focused,
  .ant-input-affix-wrapper:focus-within {
    box-shadow: 0 0 0 3px rgba(180, 216, 32, 0.2);
    border-radius: 8px;
  }

  .ant-input-affix-wrapper-focused .ant-input,
  .ant-input-affix-wrapper:focus-within .ant-input {
    border-color: rgba(19, 45, 7, 0.44);
  }

  .login-submit-button {
    width: 100%;
    margin-bottom: 12px;
    font-weight: 700;
    border-radius: 8px;
    height: 42px;
    letter-spacing: 0.01em;
  }

  .login-tooltip-item {
    margin-top: 8px;
  }
`

const FieldLabel = styled.span`
  display: block;
  margin-bottom: 6px;
  text-align: left;
  font-size: 0.8rem;
  font-weight: 600;
  letter-spacing: 0.01em;
  color: ${({ theme }) => theme.colours.seaweedGreen};
`

const StyledInputIcon = styled(Icon)`
  color: rgba(0, 0, 0, 0.32);
`

const ActionItem = styled(Item)`
  margin-bottom: 14px;
`

const AuthLink = styled.a`
  color: ${({ theme }) => theme.colours.seaweedGreen};
  font-size: 0.86rem;
  margin-top: 4px;
  font-weight: 500;

  &:hover {
    color: ${({ theme }) => theme.colours.seaweedGreen};
    text-decoration: underline;
  }
`

const TooltipHint = styled.span`
  cursor: pointer;
  color: #666666;
  font-size: 0.84rem;
  display: inline-flex;
  align-items: center;
  gap: 6px;

  &:hover {
    color: #4f4f4f;
    text-decoration: underline;
  }
`

const WrappedNormalLoginForm = Form.create({ name: 'normal_login' })(
  NormalLoginForm,
)

export default WrappedNormalLoginForm
